import { LOCAL_IMAGES } from '@qima-labs/app/shared/constants/images.constants';
import { DialogRef } from '@qsp-ui-library/components/modal/shared/classes/dialog.ref';
import { DialogCommonModule } from '@qsp-ui-library/components/modal/shared/components/dialog-common/dialog-common.module';
import { IMyWindow } from '@qsp-ui-library/interfaces/my-window.interface';
import { QimaButtonService } from '@qsp-ui-library/services/exported-services/qima-button/qima-button.service';
import { QimaIconService } from '@qsp-ui-library/services/exported-services/qima-icon/qima-icon.service';
import { WINDOW } from '@qsp-ui-library/tokens/window.token';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QimaButtonModule } from '@qima/ngx-qima';

@Component({
  selector: 'app-user-guide',
  templateUrl: './user-guide.component.html',
  styleUrls: ['./user-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DialogCommonModule, TranslateModule, QimaButtonModule],
})
export class UserGuideComponent<T> {
  public readonly helpGuidePicture: string = LOCAL_IMAGES.helpGuide;
  public readonly plankPicture: string = LOCAL_IMAGES.plank;

  public constructor(
    @Inject(DialogRef) private readonly _dialogRef: DialogRef<T>,
    @Inject(WINDOW) private readonly _window: IMyWindow,
    public readonly qimaButton: QimaButtonService,
    public readonly qimaIcon: QimaIconService
  ) {}

  public onDownloadPdfClick(): void {
    this._window.open('https://static.files.qima.com/legacy/qima/myQIMA_User_Guide_2024.pdf');
  }

  public onCloseClick(): void {
    this._dialogRef.close();
  }
}
